(function ($) {
    'use strict';

    /**
     *Функциия открытия\закрытия селекта по клику.
     *@return {jQuery}
     */

    $.fn.openSelectTickets = function () {
        const $self = $(this);
        const $selectTicketsBtn = $self.find('.js-select-btn');
        const $filterButton = $self.find('.js-filter-button');

        /**
         *Открывает выпадающий список
         */
        const openSelect = () => {
            $self.addClass('active');
        };

        /**
         *Скрывает выпадающий список
         */
        const closeSelect = () => {
            $self.removeClass('active');
        };

        /**
         *Показывает либо скрывает список
         */
        const setSelectState = () => {
            ($self.hasClass('active')) ? closeSelect() : openSelect();
        };


        /**
         * Скрывает список если клик вне открытого списка
         * @param {object} e
         */
        const documentClickHandler = function (e) {
            let $dropDown = $('.js-select-dropdown *');
            if ($self.hasClass('active')  && !$(e.target).is($dropDown) && !$(e.target).is($selectTicketsBtn))  {
                closeSelect();
            }
        };

        /**
         *Инициализация плагина
         */
        const init = () => {
            $selectTicketsBtn.on('click', function () {
                setSelectState();
            });

            $filterButton.on('click', function () {
                closeSelect();
            });

            $(document).on('click', documentClickHandler);
        };

        init();

        return this;
    };
})(jQuery);
